<template>
  <div class="download-con">
    <div class="img-con">
      <img class="img" :src="checkQiNiuUrl('ant-wx/logo/云柑社区logo.png')" alt="">
    </div>
    <div class="text-con">
      <div class="name">云柑社区</div>
      <!--<div class="text">京东社交电商战略合作伙伴<br>区块链电商通证生态引领者</div>-->
      <!--<div class="text">让企业数字化更简单<br>新组织·新生态</div>-->
      <div class="text">云上新社区<br>社区生态加速器</div>
    </div>
    <div class="btn-con">
      <div class="btn" @click="goInvitePage">立即打开</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 推广链接跳转
    goInvitePage(){
      let url = '';
      if(this.$route.query.inviteUserId){ //如果邀请链接中有 邀请人的openId
        url = '/h5/register?inviteUserId=' + this.$route.query.inviteUserId
      }else {
        url = '/h5/register?inviteUserId=' + this.session('userOpenId') || '0608';
      }
      this.$router.push( url );
    },
  }
}
</script>

<style lang="less" scoped>
  .download-con{
    display: flex;height: 55px;
    /*background-color: #e0f5ff;*/
    /*background-color: #fff8f8;*/
    background-color: #fff;
    .img-con{
      width: 60px;
      display: inline-flex;justify-content: center;align-items: center;
      .img{
        display: block;width: 37px;height: 37px;border-radius: 5px;
      }
    }
    .text-con{
      flex: 1;display: inline-flex;flex-direction: column;
      justify-content: center;
      .name{
        font-size: 13px;color: #000;padding-bottom: 2px;
      }
      .text{font-size: 11px;color: #666;}
    }
    .btn-con{
      width: 87px;
      display: inline-flex;justify-content: center;align-items: center;
      .btn{
        display: inline-flex;justify-content: center;align-items: center;
        width: 63px;height: 28px;border-radius: 3px;font-size: 11px;
        /*border: 1px solid #2686e8;color: #2686e8;*/
        border: 1px solid #FF9200;color: #FF9200;

      }
    }
  }
</style>